module.exports = __webpack_public_path__ + "img/Floor plans.c065682e.png";